"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TxParser = exports.TransferType = exports.TradeType = exports.Status = exports.Dex = void 0;
var Dex;
(function (Dex) {
    Dex["Thor"] = "thor";
    Dex["Zrx"] = "zrx";
})(Dex = exports.Dex || (exports.Dex = {}));
var Status;
(function (Status) {
    Status["Confirmed"] = "confirmed";
    Status["Pending"] = "pending";
    Status["Failed"] = "failed";
    Status["Unknown"] = "unknown";
})(Status = exports.Status || (exports.Status = {}));
var TradeType;
(function (TradeType) {
    TradeType["Trade"] = "trade";
    TradeType["Refund"] = "refund";
})(TradeType = exports.TradeType || (exports.TradeType = {}));
var TransferType;
(function (TransferType) {
    TransferType["Send"] = "send";
    TransferType["Receive"] = "receive";
})(TransferType = exports.TransferType || (exports.TransferType = {}));
var TxParser;
(function (TxParser) {
    TxParser["Cosmos"] = "cosmos";
    TxParser["Yearn"] = "yearn";
    TxParser["UniV2"] = "uniV2";
    TxParser["ZRX"] = "zrx";
    TxParser["Thor"] = "thor";
    TxParser["Foxy"] = "foxy";
    TxParser["WETH"] = "weth";
})(TxParser = exports.TxParser || (exports.TxParser = {}));
